import { render } from "./ProfileChoice.vue?vue&type=template&id=e2d70ecc"
import script from "./ProfileChoice.vue?vue&type=script&lang=js"
export * from "./ProfileChoice.vue?vue&type=script&lang=js"

import "./ProfileChoice.vue?vue&type=style&index=0&id=e2d70ecc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__